module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1e4fc169fa222ff92a543c090adab467.png";